import { Access } from "@hooks/trpc/useAccesses";
import { useSongs } from "@hooks/trpc/useSongs";

export const useIsDjSetMusicAccess = (access: Access | undefined) => {
  const accessSong = access?.type === "music" ? access.songs.at(0) : undefined;
  const { query } = useSongs(accessSong?.id ? [accessSong.id] : undefined, {
    enabled: !!accessSong?.id,
  });

  const catalogSong = query.data?.at(0);

  return Boolean(accessSong?.isSetList || catalogSong?.isSetList);
};
